import React from 'react';
import { Badge as AntBadge } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Color from '../../enums/color';
const StyledBadge = styled(AntBadge) `
  color: ${props => props.color};

  & .ant-badge-count {
    background: ${props => props.background};
  }
  
  .ant-badge-status-text {
    color: ${props => props.color};
  }
`;
const Badge = ({ text, background = Color.ElectricBlue, children, ...rest }) => {
    const { t: translate } = useTranslation();
    return (<StyledBadge text={translate(text)} {...rest} background={background}>
      {children}
    </StyledBadge>);
};
export default Badge;
